import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { BusinessListPage } from './BusinessListPage';
import { BusinessDetailPage } from './BusinessDetailPage';
import { AdminBusinessesPage } from './AdminBusinessesPage';

export function BusinessArchePage() {
  return (
    <ArcheLayout>
      <Routes>
        <Route path="/" element={<BusinessListPage />} />
        <Route path="/admin" element={<AdminBusinessesPage />} />
        <Route path="/:businessId" element={<BusinessDetailPage />} />
      </Routes>
    </ArcheLayout>
  );
}
